// extracted by mini-css-extract-plugin
export default {"moon":"moon_moon__LBTbH","rotating":"moon_rotating__FFMvy"};